import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ConfirmModal } from '@app/shared/modals';
import { AppFilter } from '@app/shared/models';
import { SuiModalService, ModalSize } from '@richardlt/ng2-semantic-ui';
import {
  NewIndividualModal,
  LinkDocumentModal,
  EditSharesModal,
  NewCompanyModal,
} from '../../../modals';
import { Subject } from 'rxjs';
import { map, take, takeUntil, tap } from 'rxjs/operators';
import { NavigationStart, Router, ActivatedRoute } from '@angular/router';
import {
  AolService,
  CompanyService,
  DashboardProvider,
  DocumentService,
  OrganizationService,
} from '../../../services';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CompanyOwnershipService } from '@app/shared/services/company-ownership.service';
import { environment } from 'src/environments/environment';
interface Document {
  documentTypeId: string;
  documentTypeName: string;
  isRequired: boolean;
  isActive: boolean;
  dateCreated: string;
  dateModified: string;
  group: any;
  createdBy: string;
  modifiedBy: string;
  uploadedFiles?: File[];
}
interface MyObjectType {
  countries: any[];
  shareHoldingAmount: number;
  item: string;
  affiliateTypeId: string;
  affiliateTypeName: string;
  usePercentage?: boolean;
  previoudDirector?: any[];
}
@Component({
  selector: 'app-company-ownership-structure',
  templateUrl: './ownership-structure.component.html',
  styleUrls: ['./ownership-structure.component.scss'],
})
export class CompanyOwnershipStructureComponent implements OnInit {
  companyDirectors = [];
  success: any;
  error: any;
  unsubscribe$: Subject<boolean> = new Subject();
  filter: AppFilter = new AppFilter();
  totalItems: number = 0;
  rows: number = 2;
  currentPage: number = 1;
  maxSize: number = 7;
  organizationId: string;
  companyType: Array<any> = [];
  baseUrl = environment.API_SERVER;
  ownershipType: Array<any> = [];
  countries: Array<any> = [];
  isEdit: boolean = false;
  savingMode: 'save' | 'later' = 'save';
  chatLink;

  isVerifiedRoute(): boolean {
    return this.router.url.includes(
      '/contractor/company/ownership-structure/verified'
    );
  }
  isPendingRoute(): boolean {
    return this.router.url.includes(
      '/contractor/company/ownership-structure/pending'
    );
  }
  isHistoryRoute(): boolean {
    return this.router.url.includes(
      '/contractor/company/ownership-structure/history'
    );
  }

  companyShareholderForm: FormGroup;
  currentForm: FormGroup;
  changeRequestId;
  result = [];
  documents = [];
  searchFilter = {
    groupOp: 'OR',
    rules: [
      {
        field: 'firstName',
        op: 'cn',
        data: '',
      },
      {
        field: 'lastName',
        op: 'cn',
        data: '',
      },
    ],
  };
  optionFilter = {
    groupOp: 'OR',
    rules: [
      {
        field: 'optionType.optionTypeId',
        op: 'eq',
        data: 'individual_ownership_type',
      },
    ],
  };
  directorStatus: string;
  message;
  redirect_url;
  applicationType;
  initialDirectorsStructure = [];
  affiliateTypeName!: string;
  affiliateTypeId!: string;
  companyTypeId = JSON.parse(window.localStorage.getItem('user')).organizationId
    .jpaContractor.companyType.optionId;
  allStatus: any;
  typeStructure!: string;
  subject = new Subject<boolean>();
  personnelStructureKeys!: string[];
  structureObject: any;
  pendingArr: boolean[] = [];
  companyAffiliateTypes;
  allAffiliateTypes;
  allStructures = [];
  redirect_params: any;
  updateMode: boolean = false;
  documentsValid = false;
  documentss: Document[];
  uploads;
  allLinkedDocuments: any = [];
  uploadedDocuments: any = [];
  allDocuments: any = [];
  documentUploaded: any = [];
  usePercentage: boolean = false;
  shareholdingAmount: number;
  pendingStructure: number = 0;
  historyFilter: AppFilter = new AppFilter();
  savedChangeRequestExisting: boolean = false;
  savedPreviousStructure: any;
  savedOrLater: boolean = false;
  // companyType = 'business_name';
  constructor(
    private modalService: SuiModalService,
    private dashboardSvc: DashboardProvider,
    private companySvc: CompanyService,
    private organizationSvc: OrganizationService,
    private documentSvc: DocumentService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private aolService: AolService
  ) {
    this.message = window.localStorage.getItem('message');
    this.applicationType = window.localStorage.getItem('application_type');
    this.redirect_url = window.localStorage.getItem('redirect_url');
    this.redirect_params = window.localStorage.getItem('redirect_params')
      ? JSON.parse(window.localStorage.getItem('redirect_params'))
      : null;
    this.historyFilter = new AppFilter({ sidx: 'dateCreated', rows: 10 });
    if (
      this.companyTypeId === 'business_name_actual' ||
      this.companyTypeId === 'business_name'
    ) {
      this.usePercentage = true;
    }
    this.organizationId = window.localStorage.getItem('organizationId');
    this.filter = new AppFilter({ sidx: 'dateCreated', rows: 100 });
    // this.getVerificationStatus();
    this.chatLink = `/contractor/chat/${this.organizationId}/message`;
    this.getRecord();

    // GET PERSONNEL TYPE
    this.activatedRoute.queryParams.subscribe((params) => {
      this.affiliateTypeId = params.typeId;
      this.affiliateTypeName = params.typeName;
      this.filter.filters = JSON.stringify(this.searchFilter);
      this.updateMode = false;
      this.savedOrLater = true;
      this.pendingStructure = 0;
      this.getPage(1);
      this.getDocumentUploaded();
    });
    if (window.location.href.includes('update-mode')) {
      this.updateMode = true;
    }
  }

  onUsePercentageChange(value: boolean) {
    this.usePercentage = value;
  }

  getVerificationStatus() {
    this.callStarted();
    this.dashboardSvc
      .getStatus({
        organizationId: this.organizationId,
      })
      .subscribe(
        (res) => {
          this.callCompleted();
          this.allStatus = res;
          this.personnelStructureKeys = Object.keys(res).filter((key) =>
            key.includes('STRUCTURE')
          );
          let statusKeys = Object.keys(this.allStatus);
          this.typeStructure = statusKeys.find((statusKey) =>
            statusKey
              .toLowerCase()
              .includes(this.affiliateTypeName.toLowerCase())
          );
          this.getSavedChangeRequest();
          this.getPageHistory(1);
        },
        (error) => {
          this.callCompleted();
        }
      );
  }
  getSavedChangeRequest() {
    this.callStarted();
    this.companySvc
      .getSavedChangeRequest({
        changeRequestType: this.typeStructure,
      })
      .subscribe(
        (res: any) => {
          this.savedChangeRequestExisting = res.changes ? true : false;
          this.savedPreviousStructure = JSON.parse(res.changes);

          if (
            this.savedChangeRequestExisting &&
            this.savedPreviousStructure?.[0]?.documents?.length > 0
          ) {
            this.allLinkedDocuments = this.savedPreviousStructure[0].documents;
          } else {
            this.allLinkedDocuments = [];
          }
          console.log(this.allLinkedDocuments, 'alllinkeddod');
          this.callCompleted();
        },
        (error) => {
          this.savedChangeRequestExisting = false;
          this.callCompleted();
        }
      );
  }
  getDocumentUploaded() {
    this.aolService
      .getDocumentUpload({
        optionId: this.affiliateTypeId,
      })
      .subscribe(
        (res: any) => {
          this.uploads = res.filter((item) => item.isActive);
          this.uploads.sort((a, b) => b.isRequired - a.isRequired);
          this.documentss = this.uploads.map((doc) => ({
            ...doc,
            uploadedFiles: [],
          }));
        },
        (error) => {
          this.error = error.error;
        }
      );
  }
  getPage(page) {
    this.filter.page = page;
    this.callStarted();
    this.companySvc
      .getCompanyDirector({
        organizationId: this.organizationId,
        ownershipType: this.affiliateTypeId,
        params: this.filter,
      })
      .subscribe(
        (res: any) => {
          this.callCompleted();
          this.totalItems = +res.records;

          this.companyDirectors = JSON.parse(JSON.stringify(res.rows));
          this.companyDirectors = this.savedChangeRequestExisting
            ? this.savedPreviousStructure
            : this.companyDirectors;
          window.localStorage.setItem(
            'initialStructure',
            JSON.stringify(this.companyDirectors)
          );
          this.getVerificationStatus();
        },
        (error) => {
          this.callCompleted();
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error
            ? error.error
            : error;
        }
      );
  }

  historyTotalItems = 0;
  redirectToExternalUrl() {
    const urlWithParams = this.buildUrlWithParams(
      this.redirect_url,
      this.redirect_params
    );

    // Redirect to the external URL
    window.location.href = urlWithParams;
  }
  private buildUrlWithParams(
    url: string,
    params: { [key: string]: any }
  ): string {
    const queryParams = Object.keys(params)
      .map(
        (key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
      )
      .join('&');

    return queryParams ? `${url}?${queryParams}` : url;
  }
  verifiedArray;
  verifiedHistory;
  verifiedStrcuture;
  pendingArray;
  pendingHistory;
  pendingStrcuture;
  pendingDocuments;
  history;
  getPageHistory(page) {
    this.callStarted();
    let pendingArray = [];
    this.pendingStructure = 0;
    this.historyTotalItems = 0;
    let pendingHistory = null;
    this.companySvc
      .getRequestHistory({
        organizationId: this.organizationId,
        changeRequestType: this.typeStructure,
        params: this.historyFilter,
      })
      .pipe(
        tap((res) => {
          this.historyTotalItems = +res['records'];
          this.currentPage = page;
          this.rows = this.filter.rows;
        })
      )
      .subscribe(
        (res: any) => {
          this.callCompleted();
          pendingArray = res['rows'].filter(
            (item) => item.status === 'PENDING'
          );

          pendingHistory = pendingArray[0];
          if (pendingHistory) {
            this.pendingStructure =
              JSON.parse(pendingHistory.toValue).length || 0;
          }
          this.pendingArray = res['rows'].filter(
            (item) => item.status === 'PENDING'
          );
          this.pendingHistory = this.pendingArray[0];
          if (this.pendingHistory) {
            this.pendingStrcuture = JSON.parse(this.pendingHistory.toValue);
            this.pendingDocuments = this.pendingStrcuture[0];
          }
          this.verifiedArray = res['rows'].filter(
            (item) => item.status === 'VERIFIED'
          );
          this.verifiedHistory = this.verifiedArray[0];
          this.history = res['rows'];
          if (this.verifiedHistory) {
            this.verifiedStrcuture = JSON.parse(this.verifiedHistory.toValue);
            this.verifiedStrcuture = this.verifiedStrcuture[0];
          }
        },
        (error) => {
          this.callCompleted();
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.message
            ? error.error.message
            : error.error
            ? error.error
            : error;
        }
      );
  }
  goToUpdate() {
    this.modalService
      .open(
        new ConfirmModal(
          'Make Updates',
          `Are you sure you want to make updates to your ${this.affiliateTypeName} Record ?`,
          ModalSize.Mini
        )
      )
      .onApprove(() => {
        if (this.savedChangeRequestExisting) {
          this.informationAboutExistingStructure();
        } else {
          this.goToUpdateFunction(false);
        }
      });
  }
  goToUpdateFunction(existing: boolean = true) {
    this.filter.rows = 1000;
    this.isEdit = true;
    this.updateMode = true;
    this.savedOrLater = false;
    this.documentss = this.documentss.map((doc) => ({
      ...doc,
      uploadedFiles: [],
    }));
    this.allLinkedDocuments = [];
    if (
      this.savedChangeRequestExisting &&
      this.savedPreviousStructure?.[0]?.documents?.length > 0
    ) {
      this.allLinkedDocuments = this.savedPreviousStructure[0].documents;
    } else {
      this.allLinkedDocuments = [];
    }
    this.companyDirectors = this.savedChangeRequestExisting
      ? this.savedPreviousStructure
      : this.companyDirectors;
    this.router.navigate(
      ['/contractor/company/ownership-structure/update-mode'],
      {
        queryParams: {
          typeId: this.affiliateTypeId,
          typeName: this.affiliateTypeName,
        },
      }
    );
  }
  informationAboutExistingStructure() {
    this.modalService
      .open(
        new ConfirmModal(
          'Existing Records',
          `You have ${this.affiliateTypeName} records that have not yet been submitted. Would you like to continue updating these existing records, or would you prefer to clear them and start over?`,
          ModalSize.Mini,
          'Continue updating existing records',
          'Start afresh'
        )
      )
      .onApprove(() => {
        this.goToUpdateFunction(true);
      })
      .onDeny(() => {
        this.deleteRequestConfirmatione('');
      });
  }
  deleteSavedRequest() {
    this.callStarted();
    this.companySvc
      .deleteSavedChangeRequest({
        changeRequestType: this.typeStructure,
      })
      .subscribe(
        () => {
          this.callCompleted();
          this.success = 'Changes Cleared Successfully';
          this.savedChangeRequestExisting = false;
          this.goToUpdateFunction(false);
        },
        (error) => {
          this.callCompleted();
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error
            ? error.error
            : error;
        }
      );
  }
  deleteRequestConfirmatione(id) {
    this.modalService
      .open(
        new ConfirmModal(
          'Delete Existing Existing Records',
          `Are you Sure you want to delete your chnages`,
          ModalSize.Mini
        )
      )
      .onApprove(() => {
        this.deleteSavedRequest();
      })
      .onDeny(() => {});
  }
  deleteRequest() {
    console.log('errr');
    this.modalService
      .open(
        new ConfirmModal(
          'Delete Pending Verification?',
          'Are you sure you want to delete this request?',
          ModalSize.Tiny
        )
      )
      .onApprove(() => {
        this.callStarted();
        this.companySvc
          .deleteRequestDocument({
            id: this.pendingHistory.changeRequestId,
          })
          .subscribe(
            () => {
              this.callCompleted();
              this.success = 'Pending Request Successfully Deleted';
              this.getPage(this.filter.page);
              this.router.navigateByUrl(
                `/contractor/company/ownership-structure/verified?typeId=${this.affiliateTypeId}&typeName=${this.affiliateTypeName}`
              );
            },
            (error) => {
              this.callCompleted();
              this.error = error.error.errorMessage
                ? error.error.errorMessage
                : error.error
                ? error.error
                : error;
            }
          );
      })
      .onDeny(() => {});
  }
  ngOnInit() {
    this.getCountry();
  }
  getCountry() {
    this.companySvc.getCountries({ filter: null }).subscribe((res) => {
      this.countries = res['rows'];
    });
  }
  addIndividual() {
    if (
      this.affiliateTypeId === 'shareholder_type' &&
      this.shareholdingAmount < 1 &&
      !this.usePercentage
    ) {
      this.error =
        'Your Total Share capital must be greater than 0, Please Edit your total share capital ';
      return;
    }
    let obj: MyObjectType = {
      countries: this.countries,
      shareHoldingAmount: this.shareholdingAmount,
      item: this.typeStructure,
      affiliateTypeId: this.affiliateTypeId,
      affiliateTypeName: this.affiliateTypeName,
      previoudDirector: this.companyDirectors,
    };

    if (this.affiliateTypeId === 'shareholder_type') {
      obj = { ...obj, usePercentage: this.usePercentage };
    }
    this.modalService
      .open(
        new NewIndividualModal(
          'New Individual Record',
          obj,
          false,
          ModalSize.Mini
        )
      )
      .onApprove((payload: any) => {
        this.getRecord();
        if (payload.length > 0) {
          payload.forEach((director) => {
            director.shareholderType = 'Individual';
          });
          this.companyDirectors = payload.concat(this.companyDirectors);
          console.log(this.companyDirectors, 'too');
        }
      })
      .onDeny(() => {});
  }
  checkDisabled() {
    if (this.affiliateTypeId === 'shareholder_type') {
      return !(
        this.returnTotalShareholding() >= 99 &&
        this.returnTotalShareholding() <= 100
      );
    } else {
      return false;
    }
  }

  returnTotalShareholding() {
    let totalShareholding = 0;
    if (this.companyDirectors.length > 0) {
      totalShareholding = this.companyDirectors.reduce(
        (sum, item) => sum + item.shareholding,
        0
      );
    }
    return totalShareholding;
  }
  isSubmitDisabled(): boolean {
    return (
      this.pendingArr?.length > 0 ||
      this.uploadSupportingFilesInvalid() ||
      this.checkIfStructureChanged() ||
      this.checkDisabled()
    );
  }
  consoleThings() {
    console.log(
      'this.companyDirectors',
      this.companyDirectors,
      'this.returnTotalShareholding()',
      this.returnTotalShareholding(),
      'this.pendingArr.length',
      this.pendingArr.length,
      'this.uploadSupportingFilesInvalid()',
      this.uploadSupportingFilesInvalid(),
      'this.checkIfStructureChanged()',
      this.checkIfStructureChanged(),
      'this.uploadedDocuments',
      this.uploadedDocuments,
      'this.allLinkedDocuments',
      this.allLinkedDocuments
    );
  }
  addCompany() {
    if (
      this.affiliateTypeId === 'shareholder_type' &&
      this.shareholdingAmount < 1 &&
      !this.usePercentage
    ) {
      this.error =
        'Your Total Share capital must be greater than 0, Please Edit your total share capital ';
      return;
    }
    let obj: MyObjectType = {
      countries: this.countries,
      shareHoldingAmount: this.shareholdingAmount,
      item: this.typeStructure,
      affiliateTypeId: this.affiliateTypeId,
      affiliateTypeName: this.affiliateTypeName,
    };

    if (this.affiliateTypeId === 'shareholder_type') {
      obj = { ...obj, usePercentage: this.usePercentage };
    }
    this.modalService
      .open(
        new NewCompanyModal(
          'New Shareholder Record',
          obj,
          false,
          ModalSize.Mini
        )
      )
      .onApprove((payload: any) => {
        this.getRecord();
        if (payload.length > 0) {
          payload.forEach((director) => {
            director.shareholderType = 'Company';
          });
          this.companyDirectors = payload.concat(this.companyDirectors);
        }
      })
      .onDeny(() => {});
  }
  updateDirector(event) {
    const { payload, index } = event;
    if (payload.length > 0) {
      if (
        payload[0].actionType === 'ADD' &&
        !payload[0].organizationOwnershipId
      ) {
        this.companyDirectors[index] = payload[0];
      } else {
        this.companyDirectors = this.companyDirectors.map((obj) =>
          obj.organizationOwnershipId === payload[0].organizationOwnershipId
            ? payload[0]
            : obj
        );
      }
    }
  }
  saveCompletely() {
    if (this.typeStructure !== 'SHAREHOLDER_STRUCTURE') {
      this.companyDirectors = this.companyDirectors.map((director) => {
        director.organizationOwnershipTypeId = this.affiliateTypeId;
        if (!director.hasOwnProperty('actionType')) {
          director.actionType = 'NONE';
        }
        if (
          director.actionType === 'UPDATE' &&
          !director.organizationOwnershipId
        ) {
          director.actionType = 'ADD';
        }
        return director;
      });
      this.initialDirectorsStructure = JSON.parse(
        window.localStorage.getItem('initialStructure')
      );
      const newArray = this.initialDirectorsStructure
        .map((director) => {
          if (
            (director.actionType === 'UPDATE' ||
              director.actionType === 'DELETE') &&
            !director.organizationOwnershipId
          ) {
            return null; // Return null for elements to be deleted
          }
          return director;
        })
        .filter(Boolean);
      let payload = {
        organization: {
          organizationId: this.organizationId,
        },
        changeRequestType: this.typeStructure,
        actionType: 'UPDATE',
        fromValue: JSON.stringify(newArray),
        toValue: JSON.stringify(this.companyDirectors),
      };
      if (this.savingMode === 'save') {
        this.addRequest(payload);
      } else {
        this.saveAndContinue(payload.toValue);
      }
    }
    if (this.typeStructure === 'SHAREHOLDER_STRUCTURE') {
      this.companyDirectors = this.companyDirectors.map((director) => {
        director.organizationOwnershipTypeId = this.affiliateTypeId;
        if (!director.hasOwnProperty('actionType')) {
          director.actionType = 'NONE';
        }
        if (
          director.actionType === 'UPDATE' &&
          !director.organizationOwnershipId
        ) {
          director.actionType = 'ADD';
        }
        return director;
      });
      const newArray = this.initialDirectorsStructure
        .map((director) => {
          if (
            director.actionType === 'UPDATE' &&
            !director.organizationOwnershipId
          ) {
            return null; // Return null for elements to be deleted
          }
          return director;
        })
        .filter(Boolean);
      let payload = {
        organization: {
          organizationId: this.organizationId,
        },
        changeRequestType: this.typeStructure,
        actionType: 'UPDATE',
        fromValue: JSON.stringify(newArray),
        toValue: JSON.stringify(this.companyDirectors),
      };
      if (this.savingMode === 'save') {
        this.addRequest(payload);
      } else {
        this.saveAndContinue(payload.toValue);
      }
    }
  }
  addRequest(payload) {
    this.callStarted();
    this.organizationSvc
      .addChangeRequest({
        organizationId: this.organizationId,
        body: payload,
      })
      .subscribe(
        (res) => {
          this.success =
            'Submission successful! You will be notified once your request has been reviewed and verified.';
          window.localStorage.setItem('initialStructure', payload);
          this.savedOrLater = true;
          setTimeout(() => {
            this.updateMode = false;
            this.callCompleted();
            this.getPage(1);
            this.router.navigateByUrl(
              `/contractor/company/ownership-structure/pending?typeId=${this.affiliateTypeId}&typeName=${this.affiliateTypeName}`
            );
          }, 2000);
        },
        (error) => {
          this.callCompleted();
          if (this.pendingArr.length == 0) {
            this.error = error?.error?.errorMessage
              ? error?.error?.errorMessage
              : error?.error?.message
              ? error?.error?.message
              : error?.error
              ? error?.error
              : error;
          }
        }
      );
  }
  saveAndContinue(payload) {
    this.callStarted();
    this.organizationSvc
      .saveChangeRequest({
        changeRequestType: this.typeStructure,
        body: payload,
      })
      .subscribe(
        (res) => {
          this.success =
            'Your progress has been saved successfully. You can return later to continue editing and complete your updates.';
          window.localStorage.setItem('initialStructure', payload);
          this.savedOrLater = true;
          this.callCompleted();
        },
        (error) => {
          this.callCompleted();
          if (this.pendingArr.length == 0) {
            this.error = error?.error?.errorMessage
              ? error?.error?.errorMessage
              : error?.error?.message
              ? error?.error?.message
              : error?.error
              ? error?.error
              : error;
          }
        }
      );
  }
  hasChanges() {
    return false;
  }
  confirmNavigationFromPage() {
    if (!this.checkIfStructureChanged()) {
      this.modalService
        .open(
          new ConfirmModal(
            'Discard Changes',
            'You have unsaved changes, do you want to leave this page and discard them?'
          )
        )
        .onApprove(() => {
          this.subject.next(true);
        })
        .onDeny(() => {
          this.subject.next(false);
        });
    } else {
      setTimeout(() => this.subject.next(true), 1);
    }
  }
  confirmAndSubmit(type) {
    this.savingMode = type;
    this.modalService
      .open(
        new ConfirmModal(
          `${type === 'save' ? 'Submit Changes' : 'Save and Continue Later '}`,
          `Are you okay with the changes been made? `,
          ModalSize.Mini,
          'Yes, Save',
          'No'
        )
      )
      .onApprove(() => {
        this.saveStructure();
      });
  }
  filterDuplicateFiles(files: File[]): File[] {
    const fileNames = new Set<string>();
    return files.filter((file) => {
      if (fileNames.has(file.name)) {
        return false;
      } else {
        fileNames.add(file.name);
        return true;
      }
    });
  }

  saveStructure() {
    this.uploadedDocuments = this.documentss
      .filter((doc) => doc.uploadedFiles && doc.uploadedFiles.length > 0)
      .map((doc) => ({
        ...doc,
        uploadedFiles: this.filterDuplicateFiles(doc.uploadedFiles),
      }));
    let data: any = this.uploadedDocuments;
    if (data && data.length > 0) {
      for (const documentType of data) {
        for (const document of documentType.uploadedFiles) {
          const size = document.size;
          if (size > 10 * 1024 * 1024) {
            this.error = `File (${document.name}) size is too large, Maximum file size is 10MB`;
            return;
          }
        }
      }
    }

    if (this.allLinkedDocuments.length > 0) {
      this.submitDocument();
      return;
    }
    this.submitDocument();
  }
  submitDocument() {
    console.log(
      this.uploadedDocuments,
      this.allLinkedDocuments,
      'uploadedDocuments'
    );
    if (
      this.savingMode === 'later' &&
      this.uploadedDocuments.length === 0 &&
      this.allLinkedDocuments.length === 0
    ) {
      this.saveCompletely();
      return;
    }
    if (this.documentss.length > 0) {
      if (this.uploadedDocuments.length > 0) {
        let data: any = this.uploadedDocuments;
        for (const documentType of data) {
          for (const document of documentType.uploadedFiles) {
            const formData: FormData = new FormData();
            const file = document;
            formData.append('file', file);
            let formValue = {
              documentDescription: 'supporting document',
              documentName: documentType.documentTypeName,
              documentTypeId: documentType.documentTypeId,
            };
            let payload: any = { formValue: formValue, formData: formData };
            this.allDocuments.push(payload);
          }
        }
        this.allDocuments.map((item, index) => {
          this.processUpload(item, index);
        });
      } else if (this.allLinkedDocuments.length > 0) {
        this.onUploadFile();
      } else {
        this.error = 'Please upload all required documents';
      }
    } else {
      this.saveCompletely();
    }
  }
  processUpload(data, i) {
    let uploadFormData = data['formData'];
    const values = data['formValue'];
    const jsonse = JSON.stringify(values);
    const blob = new Blob([jsonse], { type: 'application/json' });
    uploadFormData.append('data', blob);
    this.success = null;
    this.error = null;
    this.callStarted();
    this.documentSvc
      .uploadDocument({
        organizationId: this.organizationId,
        body: uploadFormData,
      })
      .subscribe(
        (res: any) => {
          this.callCompleted();
          this.documentUploaded.push(res);
          if (this.documentUploaded.length === this.allDocuments.length) {
            this.onUploadFile();
          }
        },
        (error) => {
          this.callCompleted();
          this.error = 'Error while uploading Documents Retry';
        }
      );
  }
  onUploadFile() {
    let filledDocumentsArray = [];
    this.allLinkedDocuments.map((item) => filledDocumentsArray.push(item));
    this.documentUploaded.map((item) => filledDocumentsArray.push(item));
    let requiredDocument = this.uploads.filter((item) => {
      return item['isRequired'];
    });
    const documentTypeIdSet = new Set(
      filledDocumentsArray.map((item) => item.documentTypeId?.documentTypeId)
    );

    // Filter the requiredDocument array based on the presence of documentTypeId in the Set
    const objectsNotInSecondArray = requiredDocument.filter(
      (item) => !documentTypeIdSet.has(item.documentTypeId)
    );
    if (objectsNotInSecondArray.length > 0) {
      this.error = 'Please upload the required Document';
      return;
    } else {
      this.companyDirectors.map((director) => {
        director.documents = filledDocumentsArray;
      });
      this.saveCompletely();
    }
  }
  LinkDocument(data) {
    this.modalService
      .open(
        new LinkDocumentModal(
          `Select and link existing documents from ${data} Document Type`,
          '',
          data,
          this.uploads,
          ModalSize.Mini
        )
      )
      .onApprove((documents: any) => {
        documents.forEach((item) => {
          const existingItem = this.allLinkedDocuments.find(
            (doc) => doc.documentId === item.documentId
          );
          if (!existingItem) {
            this.allLinkedDocuments.push(item);
          }
        });
      })
      .onDeny(() => {});
  }
  uploadSupportingFilesInvalid() {
    const uploadedDocuments = this.documentss
      ?.filter((doc) => doc.uploadedFiles && doc.uploadedFiles.length > 0)
      ?.map(({ uploadedFiles, ...rest }) => ({ ...rest, uploadedFiles }));
    if (!this.uploads) {
      return true;
    }
    if (this.uploads.length > 0) {
      return (
        uploadedDocuments?.length < 1 && this.allLinkedDocuments?.length < 1
      );
    }
  }
  checkIfStructureChanged() {
    this.initialDirectorsStructure =
      JSON.parse(window.localStorage.getItem('initialStructure')) || [];

    const hasAddOrUpdate = this.companyDirectors?.some(
      (item) => item.actionType === 'ADD' || item.actionType === 'UPDATE'
    );

    if (this.savedOrLater === true) {
      return true;
    }

    if (hasAddOrUpdate && this.savingMode === 'save') {
      return false;
    }

    return (
      (this.initialDirectorsStructure?.length || 0) ===
      (this.companyDirectors?.length || 0)
    );
  }
  editShares() {
    this.modalService
      .open(
        new EditSharesModal(
          'Edit Total Share Capital',
          this.shareholdingAmount,
          ModalSize.Mini
        )
      )
      .onApprove(() => {
        this.getRecord();
      })
      .onDeny(() => {});
  }
  getRecord() {
    this.callStarted();
    this.dashboardSvc.getCompanyDetail({}).subscribe(
      (res) => {
        this.callCompleted();
        this.shareholdingAmount = res['totalShareCapital']
          ? res['totalShareCapital']
          : 0;
      },
      (error) => {
        this.callCompleted();
        this.error = error?.error?.errorMessage
          ? error?.error?.errorMessage
          : error?.error?.message
          ? error?.error?.message
          : error?.error
          ? error?.error
          : error;
      }
    );
  }

  callStarted() {
    this.pendingArr.push(true);
  }

  callCompleted() {
    this.pendingArr.pop();
  }
}
